import { api } from '../lib/api';
import type {
  CreatedRequestLink,
  RequestLink,
  RequestLinkPublic,
  RequestLinksResponse,
} from '../lib/types';

export async function fetchRequestLinks(): Promise<RequestLink[]> {
  const response = await api<RequestLinksResponse>('/v1/request-links');
  return response.links;
}

export interface NewRequestLink {
  label: string;
  orgId?: string;
  expiresInDays?: number;
  maxVideos?: number;
}

export function createRequestLink(body: NewRequestLink): Promise<CreatedRequestLink> {
  return api<CreatedRequestLink>('/v1/request-links', { method: 'POST', body });
}

export function updateRequestLink(
  id: string,
  body: { disabled?: boolean; label?: string },
): Promise<{ id: string; label: string; disabled: boolean }> {
  return api<{ id: string; label: string; disabled: boolean }>(`/v1/request-links/${id}`, {
    method: 'PATCH',
    body,
  });
}

/**
 * Public lookup for /r/:token. No auth: this is the first thing an outsider's
 * browser asks, before any Firebase session exists.
 */
export function fetchRequestLinkPublic(token: string): Promise<RequestLinkPublic> {
  return api<RequestLinkPublic>(`/v1/r/${token}`, { auth: 'none' });
}
